export default __webpack_public_path__ + "static/media/JobFive4.9c0337b5.jpg";